export default {"src":"/_next/static/media/WhoWeAre_019A.58ec5a36.JPG","height":692,"width":1920};